import type { MarketplaceId } from "./types";

export const MARKETPLACE_LABEL_KEY: Record<MarketplaceId, string> = {
  shopee: "mp_shopee",
  tiktok: "mp_tiktok",
  lazada: "mp_lazada",
};
